<template>
  <div>
    <div class="cardContainer" style="min-width: 1630px;">
      <div class="topBar">
        <!--搜索框-->
        <div class="opeItem">
          <el-input v-model="keyWords" placeholder="请输入应用软件名称" clearable @clear="searchData"
            @keyup.enter.native="searchData">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="searchData"></i>
          </el-input>
        </div>
        <!--应用软件类型筛选-->
        <div class="opeItem">
          <div class="itemTitle">类型</div>
          <el-select v-model="appType" placeholder="请选择" :clearable="true" @change="searchData">
            <el-option v-for="item in appTypeList" :key="item.label" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!--时间筛选-->
        <div class="opeItem">
          <el-date-picker v-model="timeSelect" @change="searchData" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="futureCantChoose"></el-date-picker>
        </div>
        <!--应用软件状态筛选-->
        <div class="opeItem">
          <div class="itemTitle">状态</div>
          <el-select v-model="appStatus" placeholder="请选择" :clearable="true" @change="searchData" style="width: 160px;">
            <el-option v-for="item in appStatusList" :key="item.label" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!--按钮栏-->
        <div class="opeItem">
          <div class="btnForPub btnMr" @click="openAddDialog">新增</div>
          <div class="btnForPub btnMr" @click="batchPublishApp">批量发布</div>
          <div class="btnForPub" @click="batchCancelPublishApp">批量取消发布</div>
        </div>
      </div>
      <!--表格-->
      <div class="tableContainer">
        <el-table :data="tableData" @selection-change="handleSelectionChange" style="width: 1600px;margin: auto;"
          :header-cell-style="{ background: '#d3d9e1', color: '#4C545D', fontSize: '18px' }"
          :cell-style="{ fontSize: '14px', color: '#333333' }" stripe border>
          <div slot="empty" style="font-size: 18px;text-align: center;color: #333333">
            暂无数据
          </div>
          <el-table-column align="center" type="selection"></el-table-column>
          <el-table-column align="center" label="序号" width="70">
            <template slot-scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="应用软件名称" prop="applyName"></el-table-column>
          <el-table-column align="center" label="类型" prop="applytypeName"></el-table-column>
          <el-table-column align="center" label="版本" prop="version" width="100"></el-table-column>
          <el-table-column align="center" label="运行环境" prop="operatingCarrier"
            class-name="breakWords"></el-table-column>
          <el-table-column align="center" label="状态" prop="statusName" width="100"></el-table-column>
          <el-table-column align="center" label="更新时间" prop="updateTime" width="160"></el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <div class="opeBtn" style="width: 56px;" @click="changeOnePublishStatus(scope.row)">
                {{ scope.row.applyStatus === 2 ? '取消发布' : '发布' }}
              </div>
              <div class="opeBtn" @click="openPreviewDialog(scope.row)">查看详情</div>
              <div class="opeBtn" :style="{ cursor: scope.row.applyStatus === 2 ? 'not-allowed' : 'pointer' }"
                @click="openEditDialog(scope.row)">编辑</div>
              <div class="opeBtn" @click="delApp(scope.row)">删除</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination style="text-align: center; margin-top: 20px; margin-bottom: 10px;"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[5, 10, 25, 50, 100, 150]" :page-size="pageSize" layout="total,sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!--添加编辑弹窗-->
    <el-dialog :visible.sync="addOrEditVisible" width="550px" @closed="closeAddOrEditDialog"
      :close-on-click-modal="false">
      <div slot="title" class="dialogTitle">{{ dialogTitle }}</div>
      <el-form ref="appForm" style="text-align: left;" label-position="right" label-width="160px" :model="appDtl"
        :rules="rules">
        <el-form-item label="封面" prop="appImg.imageId" :rules="[
          { required: true, message: '不能为空', trigger: 'change' },
        ]">
          <div>
            <el-upload :class="appDtl.appImg.imageUrlArr.length === 0 ? '' : 'onlyOneImgUploader'"
              accept="image/png,image/jpeg" list-type="picture-card" action="" :limit=1
              :file-list="appDtl.appImg.imageUrlArr" :on-preview="handlePictureCardPreview" :http-request="uploadImage"
              :before-upload="beforeUploadImage" :on-remove="handleRemoveImage">
              <i class="el-icon-plus"></i>
            </el-upload>
            <div
              style="font-size: 13px;color: #333333;word-break: break-word;line-height: 1.2;text-align: left;padding-top: 5px;">
              注：建议图片宽高为100X100，图片大小2M以内，只能以jpg、png、jpeg、svg、gif格式上传
            </div>
          </div>
          <el-dialog append-to-body :visible.sync="imgPreviewVisible">
            <img width="100%" :src="appDtl.appImg.imageUrl" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="名称" prop="applyName">
          <el-input style="width: 300px;" v-model="appDtl.applyName" :maxlength="$len.input"
            placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="价格" prop="price" :rules="[
          { required: true, message: '不能为空', trigger: ['blur', 'change'] },
        ]">
          <el-input style="width: 300px;" v-model="appDtl.price" :maxlength="$len.input" placeholder="请输入"
            @input="priceRegExp($event)" @blur="blurCheck()">
            <div slot="suffix">元</div>
          </el-input>
        </el-form-item>
        <el-form-item label="类型" prop="appType" :rules="[
          { required: true, message: '不能为空', trigger: 'change' },
        ]">
          <el-select style="width: 300px;" v-model="appDtl.appType">
            <el-option v-for="item in appTypeList" :key="item.label" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="导入" prop="appId" :rules="[
          { required: true, message: '不能为空', trigger: 'change' },
        ]">
          <div>
            <el-upload accept="gmos" action="" :limit=1 :file-list="appDtl.appArr" :http-request="uploadAppFile"
              :before-upload="beforeUpload" :on-remove="handleRemoveFile">
              <el-button size="small" type="primary">选择文件</el-button>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="版本" prop="version">
          <el-input style="width: 300px;" v-model="appDtl.version" :maxlength="$len.input" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="运行环境" prop="premise" :rules="[
          { required: true, message: '不能为空', trigger: 'change' },
        ]">
          <el-select multiple clearable style="width: 300px;" v-model="appDtl.premise">
            <el-option v-for="item in premiseList" :key="item.label" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支持设备类型" prop="dvcType" :rules="[
          { required: true, message: '不能为空', trigger: 'change' },
        ]">
          <el-select filterable multiple clearable style="width: 300px;" v-model="appDtl.dvcType">
            <el-option v-for="item in dvcTypeList" :key="item.label" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支持设备厂家" prop="dvcMaster">
          <el-input style="width: 300px;" v-model="appDtl.dvcMaster" :maxlength="$len.input"
            placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="支持设备协议" prop="dvcAgreement" :rules="[
          { required: true, message: '不能为空', trigger: 'change' },
        ]">
          <el-select filterable multiple clearable style="width: 300px;" v-model="appDtl.dvcAgreement">
            <el-option v-for="item in dvcAgreementList" :key="item.label" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="功能描述" prop="desc">
          <el-input type="textarea" style="width: 300px;" v-model="appDtl.desc" :maxlength="$len.area"
            :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入"></el-input>
        </el-form-item>
        <div style="text-align: right;">
          <div class="btnForPub btnMr" style="width: 80px;" @click="closeAddOrEditDialog">取消</div>
          <div class="btnForPub btnMr" style="width: 80px;" @click="confirmForm(0)">保存</div>
          <div class="btnForPub" style="width: 80px;" @click="confirmForm(2)">发布</div>
        </div>
      </el-form>
    </el-dialog>
    <!--查看详情弹窗-->
    <el-dialog :visible="previewVisible" width="550px" @close="closePreviewDialog" @closed="resetPreviewApp"
      :close-on-click-modal="false">
      <div slot="title" class="dialogTitle">应用软件详情</div>
      <div>
        <div class="attrItem">
          <div class="attrTitle">封面</div>
          <div class="attrValue">
            <div class="appImg">
              <img :src="previewApp.imsUrl" width="110px" height="110px" class="imgCenter">
            </div>
          </div>
        </div>
        <div class="attrItem">
          <div class="attrTitle">名称</div>
          <div class="attrValue">{{ previewApp.applyName }}</div>
        </div>
        <div class="attrItem">
          <div class="attrTitle">价格</div>
          <div class="attrValue">{{ previewApp.price }}元</div>
        </div>
        <div class="attrItem">
          <div class="attrTitle">类型</div>
          <div class="attrValue">{{ previewApp.applytypeName }}</div>
        </div>
        <div class="attrItem">
          <div class="attrTitle">版本</div>
          <div class="attrValue">{{ previewApp.version }}</div>
        </div>
        <div class="attrItem">
          <div class="attrTitle">运行环境</div>
          <div class="attrValue">{{ previewApp.operatingCarrier }}</div>
        </div>
        <div class="attrItem">
          <div class="attrTitle">支持设备类型</div>
          <div class="attrValue">{{ previewApp.deviceTypes }}</div>
        </div>
        <div class="attrItem">
          <div class="attrTitle">支持设备厂家</div>
          <div class="attrValue">{{ previewApp.deviceManufacturers }}</div>
        </div>
        <div class="attrItem">
          <div class="attrTitle">支持设备协议</div>
          <div class="attrValue">{{ previewApp.deviceProtocols }}</div>
        </div>
        <div class="attrItem">
          <div class="attrTitle">功能描述</div>
          <div class="attrValue">{{ previewApp.applyDescription }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAppPublishList,
  uploadImage,
  uploadApp,
  batchPublish,
  batchCancelPublish,
  deleteApp,
  addorEditApp
} from '../../../api/appStore/appPublish';
import {
  selectApplystypeList,
  selectDevicetypeList,
  selectDeviceprotocolList
} from "../../../api/appStore/appCommon";
import { mapGetters } from "vuex";

export default {
  name: "appPublish",
  watch: {
    'appDtl.appId': {
      handler(newVal, oldVal) {
        // 上传文件的校验需要手动补充触发
        if (this.$refs.appForm) {
          this.$refs.appForm.validateField(['appId']);
        }
      }
    },
    'appDtl.appImg.imageId': {
      handler(newVal, oldVal) {
        // 上传文件的校验需要手动补充触发
        if (this.$refs.appForm) {
          this.$refs.appForm.validateField(['appImg.imageId']);
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getUserName']),
  },
  data() {
    return {
      // 应用软件名称、版本号修改前的值存储，用于编辑时判断是否有更改这两值，用于后台重名提示
      appOldValue: {
        applyName: '',
        version: ''
      },

      // 表单规则
      rules: {
        applyName: [
          { required: true, message: '不能为空', trigger: ['blur', 'change'] },
          { validator: this.charsLimit, trigger: ['blur', 'change'] }
        ],
        // price: [
        //   { required: true, message: '不能为空', trigger: ['blur','change'] },
        //   { validator: this.priceLimit, trigger: ['blur','change'] }
        // ],
        version: [
          { required: true, message: '不能为空', trigger: ['blur', 'change'] },
          { validator: this.versionLimit, trigger: ['blur', 'change'] }
        ],
        dvcMaster: [
          { required: true, message: '不能为空', trigger: ['blur', 'change'] },
          { validator: this.charsLimit, trigger: ['blur', 'change'] }
        ],
        desc: [
          { required: true, message: '不能为空', trigger: ['blur', 'change'] },
          // { validator: this.charsLimit, trigger: ['blur','change'] }
        ],
      },
      // 时间选择范围限制
      futureCantChoose: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },

      // 弹窗相关
      dialogTitle: '',  // 弹窗标题
      showUploader: true,
      previewVisible: false,  // 查看详情弹窗
      previewApp: {
        // applyName: '',
      }, // 查看详情的APP信息
      addOrEditVisible: false,  // 添加or编辑的弹窗
      imgPreviewVisible: false, // 添加or编辑中的预览图片弹窗

      // app细节
      appDtl: {
        id: '',
        // 应用软件封面
        appImg: {
          imageUrl: '',
          imageUrlArr: [
            // {'url':'http://172.16.200.156:8088/apis/api/cafca97472454cd7b7651362832557b5.png'}
          ],  // 图片上传组件的绑定值需为list
          imageId: ''
        },
        applyName: '',  // 应用软件名称
        price: '',  // 价格
        appType: '',  // 应用软件类型
        appId: '',  // 应用软件，上传文件后返回appId
        appArr: [], // 应用软件文件上传列表
        version: '',// 应用软件版本
        premise: [],  // 运行环境
        dvcType: [],  // 支持设备类型
        dvcMaster: '',  // 支持设备厂家
        dvcAgreement: [], // 支持设备协议
        desc: '', // 功能描述
      },

      // 查询关键字
      keyWords: '',
      // 选择的应用软件类型
      appType: '',

      // 选择的时间范围
      timeSelect: [],
      // 选择的应用软件状态
      appStatus: '',

      // 应用软件类型选项
      appTypeList: [
        // { label: '设备监控', value: '1' },
      ],
      // GMOS APP状态选项
      appStatusList: [
        { label: '已发布', value: '2' },
        { label: '未发布', value: '0' },
      ],
      // 运行环境选项
      premiseList: [
        { label: 'GMLink IP控制器V3.0', value: '1' },
      ],
      // 支持设备类型
      dvcTypeList: [
        // { label: '多联机', value: '1' },
      ],
      // 支持的设备协议
      dvcAgreementList: [
        // { label: 'Modbus', value: '1' },
      ],

      // 表格数据
      tableData: [],
      // 勾选的表格数据项的id组成的数组
      idsArr: [],

      // 分页器相关
      currentPage: 1,
      pageSize: 10,
      total: 0,

      // 刷新动画效果
      showLoading1: false,
    }
  },
  methods: {
    //----------工具类----------
    // 判断编辑时是否有修改GMOS APP名称or版本
    checkKeyChange() {
      // 有修改返回1，没修改返回0
      if (this.appOldValue.applyName !== this.appDtl.applyName || this.appOldValue.version !== this.appDtl.version) {
        return '1';
      }
      return '0';
    },
    // GMOS APP版本字段的输入限制
    versionLimit(rule, value, callback) {
      if (value) {
        // let reg = /^[a-zA-Z\u4e00-\u9fa50-9_/#'-]+$/;
        let reg = /^[a-zA-Z0-9.]+$/;
        if (!reg.test(value)) {
          callback(new Error('仅支持输入字母、数字、小数点组合的字符'));
        }
        callback();
      }
      callback();
    },
    // 价格字段的输入限制
    priceLimit(rule, value, callback) {
      if (value) {
        // 整数、0~0.99、浮点数
        let reg = /(^[1-9]\d*$)|(^0(\.\d{1,2})?$)|(^[1-9]\d*\.\d{1,2}$)/;
        if (!reg.test(value)) {
          // callback(new Error('输入价格不合法'));
          callback(new Error('仅允许输入数字、小数点，且最多允许输入两位小数'));
        }
        callback();
      }
      callback();
    },
    // 输入字符限制
    charsLimit(rule, value, callback) {
      if (value) {
        let reg = /^[a-zA-Z\u4e00-\u9fa50-9_/#'-]+$/;
        if (!reg.test(value)) {
          callback(new Error('仅支持输入英文字母、中文、数字、下划线、斜线、#、\'、-组合的字符'));
        }
        callback();
      }
      callback();
    },
    //  避免弹窗数据被污染
    resetAppDtl() {
      this.appDtl = {
        id: '',
        // GMOS APP封面
        appImg: {
          imageUrl: '',
          imageUrlArr: [
            // {'url':'http://172.16.200.156:8088/apis/api/cafca97472454cd7b7651362832557b5.png'}
          ],  // 图片上传组件的绑定值需为list
          imageId: ''
        },
        applyName: '',  // GMOS APP名称
        price: '',  // 价格
        appType: '',  // GMOS APP类型
        appId: '',  // GMOS APP，上传文件后返回appId
        appArr: [], // GMOS APP文件上传列表
        version: '',// GMOS APP版本
        premise: [],  // 运行环境
        dvcType: [],  // 支持设备类型
        dvcMaster: '',  // 支持设备厂家
        dvcAgreement: [], // 支持设备协议
        desc: '', // 功能描述
      }
    },
    // 用于弥补priceRegExp的不足，小数点结尾将被去除小数点
    blurCheck() {
      let aimValue = this.appDtl.price + '';
      if (aimValue.indexOf('.') === aimValue.length - 1) {
        aimValue = aimValue.replace('.', '');
        this.appDtl.price = aimValue;
      }
    },
    // 只能输入纯数值的校验
    priceRegExp(inputEntity) {
      // inputEntity是输入的所有值，dataSource是数据源，index>0时数据源是数组，index为-1时数据源是对象、aim是标识位
      const intLimit = /[0-9]{1,20}/;
      const floatLimit = /[0-9]{1,20}[.][\d]{0,2}/;
      if (inputEntity) {
        inputEntity = inputEntity + ""; // 转为字符串
        let nn = "";
        if (inputEntity.indexOf(".") != -1) {
          // 浮点数情况
          if (inputEntity.match(floatLimit)) {
            nn = nn + inputEntity.match(floatLimit)[0] || "";
          }
        } else {
          // 整数情况
          if (inputEntity.match(intLimit)) {
            nn = nn + inputEntity.match(intLimit)[0] || "";
          }
        }
        // 开头连续0去除
        if (nn.substring(0, 1) == "0") {
          if (nn.substring(1, 2) != ".") {
            nn = 0;
          }
        }
        // 限制数值最大为
        // if (parseFloat(nn) > 10 ** 20) {
        //   nn = 10 ** 10;
        // }

        // 价格输入框
        this.appDtl.price = nn;
      }
    },
    // 时间戳转年-月-日
    toYMD(date, endFlag = 0) {
      if (date) {
        let time = new Date(date);
        let suffix = endFlag ? ' 23:59:59' : '';
        return time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate() + suffix;
      }
      return '';
    },
    resetPreviewApp() {
      this.previewApp = {
        imsUrl: '',
        applyName: '',
        price: '',
        applytypeName: '',
        version: '',
        operatingCarrier: '',
        deviceTypes: '',
        deviceManufacturers: '',
        deviceProtocols: '',
        applyDescription: '',
      };
    },
    //----------动作类----------
    // 图片预览按钮的效果
    handlePictureCardPreview() {
      this.imgPreviewVisible = true;
    },
    // 上传文件前
    beforeUpload(file) {
      // 文件类型限制
      let fileAllowList = ['.gmos'];
      const fileName = file.name ? file.name : '';
      const fileSuffix = fileName.substring(fileName.lastIndexOf(".")).toLowerCase(); // windows系统对文件名大小写不敏感，因此需要全部转小写后再进行判断
      const typeAccept = fileAllowList.indexOf(fileSuffix);// 找不到返回-1
      // 文件大小限制
      const sizeAccept = file.size / 1024 / 1024 <= 1024;
      if (typeAccept === -1) {
        this.$msg('上传文件的格式只能是：.gmos');
        return Promise.reject(false);
      }
      else if (!sizeAccept) {
        this.$message.error('上传文件的大小不能超过2MB!');
        return Promise.reject(false);
      }
      return true;
    },
    // 上传图片前
    beforeUploadImage(file) {
      const typeAccept = (file.type === 'image/jpeg') || (file.type === 'image/gif') || (file.type === 'image/png') ||
        (file.type === 'image/svg+xml') || (file.type === 'image/jpg');
      const sizeAccept = file.size / 1024 / 1024 <= 2;
      if (!typeAccept) {
        this.$msg('上传文件的格式只能是：jpg、png、jpeg、svg、gif');
      }
      if (!sizeAccept) {
        this.$message.error('上传文件的大小不能超过2MB!');
      }
      return typeAccept && sizeAccept
    },
    // 移除GMOS APP文件
    handleRemoveFile() {
      this.appDtl.appId = '';
    },
    // 移除GMOS APP封面图片
    handleRemoveImage() {
      this.appDtl.appImg.imageId = '';
      this.appDtl.appImg.imageUrl = '';
      this.appDtl.appImg.imageUrlArr = [];
      // this.showUploader = true;
    },
    // 表格勾选框改变
    handleSelectionChange(val) {
      let idsArr = [];
      for (let i = 0; i < val.length; i++) {
        idsArr.push(val[i].id);
      }
      this.idsArr = idsArr;
    },
    // 查询表格数据
    searchData() {
      this.getAppList();
    },
    // 切换分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchData();
    },
    // 切换单页大小
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.searchData();
    },
    // 打开新增弹窗
    openAddDialog() {
      if (this.$refs.appForm) {
        this.$refs.appForm.clearValidate();
      }
      this.dialogTitle = '添加GMOS APP';
      this.appDtl.id = '';
      this.addOrEditVisible = true;
    },
    // 打开编辑弹窗
    openEditDialog(rowData) {
      // 已发布状态不允许编辑
      if (rowData.applyStatus === 2) {
        return;
      }
      this.dialogTitle = '编辑GMOS APP';

      this.$nextTick(() => {
        this.appOldValue.applyName = rowData.applyName;
        this.appOldValue.version = rowData.version;

        this.appDtl.id = rowData.id;
        this.appDtl.appImg = {
          imageUrl: rowData.imsUrl,
          imageUrlArr: [
            { 'url': rowData.imsUrl }
          ],  // 图片上传组件的绑定值需为list
          imageId: rowData.imsId
        };
        this.appDtl.applyName = rowData.applyName;
        this.appDtl.price = rowData.price;
        this.appDtl.appType = rowData.applytypeId;
        this.appDtl.appArr = [
          { name: rowData.appName, url: '' }
        ];
        this.appDtl.appId = rowData.appId;
        this.appDtl.version = rowData.version;
        this.appDtl.premise = rowData.operatingCarrierIds;
        this.appDtl.dvcType = rowData.deviceTypesIds;
        this.appDtl.dvcMaster = rowData.deviceManufacturers;
        this.appDtl.dvcAgreement = rowData.deviceProtocolsIds;
        this.appDtl.desc = rowData.applyDescription;
      })

      this.addOrEditVisible = true;
    },
    // 打开查看详情弹窗
    openPreviewDialog(appDtl) {
      this.previewApp = appDtl;
      this.previewVisible = true;
    },
    // 关闭查看详情弹窗
    closePreviewDialog() {
      this.previewVisible = false;
    },
    // 关闭新增或编辑弹窗
    closeAddOrEditDialog() {
      if (this.$refs.appForm) {
        this.$refs.appForm.resetFields();
        // this.resetAppDtl();
      }
      this.appDtl.appImg.imageUrlArr = [];  // 清空图片列表
      this.appDtl.appArr = [];  // 清空上传文件的列表
      this.addOrEditVisible = false;
    },
    //----------接口类----------GMOS APP
    // 上传GMOS APP文件
    async uploadAppFile(params) {
      let formData = new FormData()
      formData.append('file', params.file)
      // 上传成功则获取appId返回
      await uploadApp(formData).then(res => {
        if (res.returnCode !== '100') { // 出错了
          this.$msg(res.returnMsg, 'error');
          this.appDtl.appArr = [];  // 清空上传文件的列表
        }
        res = res.returnData;
        this.appDtl.appId = res.appId;
      }).catch(err => err)
    },
    // 上传新闻图片
    uploadImage(params) {
      // this.showUploader = false;
      let formData = new FormData()
      formData.append('image', params.file)
      uploadImage(formData).then(res => {
        if (res.returnCode === '100') {
          res = res.returnData;
          this.appDtl.appImg.imageUrl = res.imageUrl;
          this.appDtl.appImg.imageId = res.imageId;
          this.appDtl.appImg.imageUrlArr = [{ url: res.imageUrl }];
        } else {
          this.$msg(res.returnMsg, 'error');
          this.handleRemoveImage();
        }
      }).catch(err => {
        // this.showUploader = true;
      })
    },
    // 弹窗的提交事件
    confirmForm(applyStatus) {  // 0是保存，2是发布
      this.$refs.appForm.validate((valid) => {
        if (valid) {
          if (!this.appDtl.id) {  // 添加的情况
            addorEditApp({
              createBy: this.getUserName,
              imsId: this.appDtl.appImg.imageId,  // GMOS APP封面
              applyName: this.appDtl.applyName,   // GMOS APP名称
              price: this.appDtl.price,           // 价格
              applytypeId: this.appDtl.appType,   // GMOS APP类型
              appId: this.appDtl.appId,           // GMOS APP导入
              version: this.appDtl.version,       // GMOS APP版本
              operatingCarrier: this.appDtl.premise.toString(), // 运行环境
              deviceTypes: this.appDtl.dvcType.toString(),      // 支持设备类型
              deviceManufacturers: this.appDtl.dvcMaster,       // 支持设备厂家
              deviceProtocols: this.appDtl.dvcAgreement.toString(),// 支持设备协议
              applyDescription: this.appDtl.desc,  // 功能描述
              applyStatus: applyStatus,            // GMOS APP状态
            }).then(res => {
              if (res.returnCode === '100') {
                this.$msg('新增成功', 'success');
                this.closeAddOrEditDialog();
                this.searchData();
              } else {
                this.$msg(res.returnMsg);
              }
            }).catch(e => e);
          } else if (this.appDtl.id) {  // 编辑的情况
            addorEditApp({
              createBy: this.getUserName,
              id: this.appDtl.id,                 // GMOS APPid，编辑才会带出
              imsId: this.appDtl.appImg.imageId,  // GMOS APP封面
              applyName: this.appDtl.applyName,   // GMOS APP名称
              price: this.appDtl.price,           // 价格
              applytypeId: this.appDtl.appType,   // GMOS APP类型
              appId: this.appDtl.appId,           // GMOS APP导入
              version: this.appDtl.version,       // GMOS APP版本
              operatingCarrier: this.appDtl.premise.toString(), // 运行环境
              deviceTypes: this.appDtl.dvcType.toString(),      // 支持设备类型
              deviceManufacturers: this.appDtl.dvcMaster,       // 支持设备厂家
              deviceProtocols: this.appDtl.dvcAgreement.toString(),// 支持设备协议
              applyDescription: this.appDtl.desc,  // 功能描述
              applyStatus: applyStatus,            // GMOS APP状态
              applyNameChange: this.checkKeyChange(), // 判断是否重名的参数
            }).then(res => {
              if (res.returnCode === '100') {
                this.$msg('编辑成功', 'success');
                this.closeAddOrEditDialog();
                this.searchData();
              } else {
                this.$msg(res.returnMsg);
              }
            }).catch(e => e);
          }
        }
      })
    },
    // 获取GMOS APP列表
    getAppList() {
      let data = {
        createBy: this.getUserName,
        applyName: this.keyWords,
        applytypeId: parseInt(this.appType),
        applyStatus: parseInt(this.appStatus),
        curPage: this.currentPage,
        pageSize: this.pageSize
      };
      if (this.timeSelect) {
        data.startDate = this.toYMD(this.timeSelect[0]);
        data.endDate = this.toYMD(this.timeSelect[1], 1);
      }
      getAppPublishList(data).then(res => {
        res = res.returnData
        this.total = res.count;
        this.tableData = res.applys;
      }).catch(e => e);
    },
    // 单个GMOS APP的发布/取消发布
    changeOnePublishStatus(rowData) {
      if (rowData.applyStatus === 0) {  // 未发布状态下
        batchPublish(rowData.id.toString()).then(res => {
          this.$msg('发布成功', 'success');
          this.searchData();
        }).catch(e => e);
      } else if (rowData.applyStatus === 2) { // 已发布状态下
        batchCancelPublish(rowData.id.toString()).then(res => {
          this.$msg('取消发布成功', 'success');
          this.searchData();
        }).catch(e => e);
      }
    },
    // 批量发布
    batchPublishApp() {
      if (this.idsArr.length === 0) {
        this.$msg('请勾选GMOS APP', 'warning');
        return;
      }
      batchPublish(this.idsArr.toString()).then(res => {
        this.$msg('批量发布成功', 'success');
        this.searchData();
      }).catch(e => e);
    },
    // 批量取消发布
    batchCancelPublishApp() {
      if (this.idsArr.length === 0) {
        this.$msg('请勾选GMOS APP', 'warning');
        return;
      }
      batchCancelPublish(this.idsArr.toString()).then(res => {
        this.$msg('批量取消发布成功', 'success');
        this.searchData();
      }).catch(e => e);
    },
    // 删除GMOS APP
    delApp(rowData) {
      this.$del({ title: '', msg: '请确认是否删除该GMOS APP' }).then(() => {
        // 删除末页唯一一条数据时，当前页要往前跳一页，否则搜不出数据
        if (this.currentPage > 1) {
          let maxPage = Math.ceil(this.total / this.pageSize);
          if (this.currentPage === maxPage && this.tableData.length === 1) {
            this.currentPage -= 1;
          }
        }
        deleteApp(rowData.id).then(res => {
          this.$msg('删除成功', 'success');
          this.searchData();
        }).catch(e => e);
      }).catch(e => e);
    },

    // 获取GMOS APP类型选项
    getAppTypeList() {
      selectApplystypeList().then(res => {
        if (res.returnCode === '100') {
          let dataArr = res.returnData;
          let resArr = [];
          for (let i = 0; i < dataArr.length; i++) {
            let item = {
              label: dataArr[i].applytypeName,
              value: dataArr[i].applytypeId
            };
            resArr.push(item);
          };
          this.appTypeList = resArr;
        }
      }).catch(e => e);
    },
    // 获取支持设备类型列表
    getDvcTypeList() {
      selectDevicetypeList().then(res => {
        if (res.returnCode === '100') {
          let dataArr = res.returnData;
          let resArr = [];
          for (let i = 0; i < dataArr.length; i++) {
            let item = {
              label: dataArr[i].devicetypeName,
              value: dataArr[i].id + ''
            };
            resArr.push(item);
          };
          this.dvcTypeList = resArr;
        }
      }).catch(e => e);
    },
    // 获取支持的设备协议的列表
    getDvcAgreementList() {
      selectDeviceprotocolList().then(res => {
        if (res.returnCode === '100') {
          let dataArr = res.returnData;
          let resArr = [];
          for (let i = 0; i < dataArr.length; i++) {
            let item = {
              label: dataArr[i].deviceprotocolName,
              value: dataArr[i].id + ''
            };
            resArr.push(item);
          };
          this.dvcAgreementList = resArr;
        }
      }).catch(e => e);
    }
  },
  mounted() {
    this.getAppList();
    this.resetAppDtl();

    this.getAppTypeList();
    this.getDvcTypeList();
    this.getDvcAgreementList();
  }
}
</script>

<style scoped lang="less">
/*框架样式*/
.cardContainer {
  color: #333333;
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  box-sizing: border-box;
  background-color: white;
  margin-bottom: 10px;
}

/*顶部操作栏样式*/
.topBar {
  margin: 10px 14px;
  text-align: left;

  .opeItem {
    display: inline-block;
    margin-right: 20px;

    .itemTitle {
      display: inline-block;
      font-size: 18px;
      padding: 0 10px;
    }
  }

  .opeItem:last-child {
    margin-right: 0px;
  }
}

/*按钮样式*/
.btnForPub {
  background-color: #3399FF;
  color: #FFFFFF;
  font-size: 16px;
  height: 40px;
  width: 120px;
  line-height: 40px;
  display: inline-block;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}

.btnMr {
  margin-right: 10px;
}

/*表格按钮样式*/
.opeBtn {
  cursor: pointer;
  color: #3399FF;
  display: inline-block;
  margin: 0 8px;
}

/*弹窗样式*/
.dialogTitle {
  font-size: 18px;
  color: #224E7F;
  text-align: left;
  font-weight: bold;
  border-bottom: 1px solid #EEEEEE;
}

/*上传图片框隐藏逻辑样式*/
/deep/ .onlyOneImgUploader .el-upload--picture-card {
  display: none;
  /* 上传按钮隐藏 */
}

/*查看详情样式*/
.attrItem {
  margin-bottom: 22px;
  text-align: left;

  /*标题样式*/
  .attrTitle {
    display: inline-block;
    width: 160px;
    padding-right: 12px;
    text-align: right;
    box-sizing: border-box;
    font-size: 18px;
    color: #224E7F;
    vertical-align: top;
  }

  /*数值样式*/
  .attrValue {
    display: inline-block;
    font-size: 16px;
    color: #333333;
    box-sizing: border-box;
    width: 350px;
    line-height: 27px;
    padding-left: 30px;
    word-break: break-word;

    /*GMOS APP图标样式*/
    .appImg {
      width: 120px;
      height: 120px;
      border: 2px solid #008FE0;
      border-radius: 10px;
      box-sizing: border-box;
      line-height: 116px; // 图裂放中间位置
      text-align: center;

      .imgCenter {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
}

/*保证运行环境的英文内容能正确换行*/
/deep/ .breakWords .cell {
  word-break: break-word;
}

.el-form-item {
  margin-bottom: 30px;
}
</style>
